module.exports = __webpack_public_path__ + "img/logo.59f50ba3.png";